export const formatDecimal = (num: number, decimalPlaces = 3) =>
  (+num).toFixed(decimalPlaces)

export const countDecimals = function (num: number, fallback = 0) {
  if (Math.floor(num) !== num) return num.toString().split('.')[1].length || 0
  return fallback
}
